const USER_API_ROOT = window.location.host.startsWith('localhost')
    ? `http://127.0.0.1:8000`
    : `https://aerosol-alerts.atmosphere.copernicus.eu/userapi`;


export function getNumberOfUsers() {
    const url = `${USER_API_ROOT}/number_of_users`;
    return fetchJSON<number>(url);
}

export function getAllSubs() {
    const url = `${USER_API_ROOT}/get_all_subs`;
    return fetchJSON<SubData[]>(url);
}

export function getAllUsers(accessToken: string) {
    const url = `${USER_API_ROOT}/get_all_users`;
    return fetchJSON<UserData[]>(url, { accessToken });
}

export function getUser(accessToken: string) {
    const url = `${USER_API_ROOT}/get_user`;
    return fetchJSON<UserData>(url, { accessToken });
}

export function getSubs(accessToken: string) {
    const url = `${USER_API_ROOT}/get_subs`;
    return fetchJSON<SubData[]>(url, { accessToken });
}

export function loginUser(mail: string, password: string) {
    const url = `${USER_API_ROOT}/token`;
    return fetchJSON<{ access_token: string }>(url, {
        method: 'POST',
        body: { username: mail, password }
    });
}

export function emailPasswordChangeRequest(mail: string, recaptcha: string) {
    const url = `${USER_API_ROOT}/email_password_change_request`;
    return fetchJSON<{ access_token: string }>(url, {
        method: 'POST',
        body: { mail, recaptcha }
    });
}

export function changePasswordUsingEmail(mail: string, newPassword: string, guid: string) {
    const url = `${USER_API_ROOT}/change_password_using_email`;
    return fetchJSON<{ access_token: string }>(url, {
        method: 'POST',
        body: { mail, new_password: newPassword, guid }
    });
}

export function addUser(
    firstName: string,
    lastName: string,
    mail: string,
    password: string,
    recaptcha: string
) {
    const url = `${USER_API_ROOT}/add_user`;
    return fetchJSON<{ access_token: string }>(url, {
        method: 'POST',
        body: { firstname: firstName, lastname: lastName, mail, password, recaptcha },
    });
}

export function addSub(
    accessToken: string,
    param: string,
    model: string,
    level: number,
    name: string,
    coords: string
) {
    const url = `${USER_API_ROOT}/add_sub`;
    return fetchJSON(url, {
        method: 'POST',
        accessToken,
        body: { param, model, level, name, coords },
    });
}

export function updateSub(
    accessToken: string,
    subId: number,
    param: string,
    model: string,
    level: number,
    name: string,
    //coords: string
) {
    const url = `${USER_API_ROOT}/update_sub`;
    return fetchJSON(url, {
        method: 'PATCH',
        accessToken,
        body: { sub_id: subId, param, model, level, name },
    });
}

export function removeSub(
    accessToken: string,
    subId: number
) {
    const url = `${USER_API_ROOT}/remove_sub`;
    return fetchJSON(url, {
        method: 'DELETE',
        accessToken,
        body: { sub_id: subId },
    });
}


export async function fetchJSON<T = unknown>(
    url: string,
    options: {
        method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
        accessToken?: string;
        body?: Record<string, any>;
        headers?: Record<string, string>;
    } = {}
): Promise<T> {
    const { method = 'GET', accessToken, body, headers = {} } = options;

    const fetchHeaders: Record<string, string> = {
        Accept: 'application/json',
        ...headers,
    };

    let requestBody: BodyInit | undefined;

    if (accessToken) {
        fetchHeaders['Authorization'] = `Bearer ${accessToken}`;
    }

    if (body && method !== 'GET') {
        fetchHeaders['Content-Type'] = 'application/json';
        requestBody = JSON.stringify(body);
    }

    const response = await fetch(url, {
        method,
        headers: fetchHeaders,
        body: requestBody,
        cache: 'no-cache',
    });

    if (!response.ok) {
        throw new Error(`${method} ${url} failed: ${response.status} ${response.statusText}`);
    }

    return (await response.json()) as T;
}